import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ISpecificBrickSettingsComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import {
   ChangeShowDurationAsText,
   ChangeShowProgressbar,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/presence-duration-brick-settings/presence-duration-brick-settings.actions';
import { PresenceDurationBrickSettingsStateSelectors } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/presence-duration-brick-settings/presence-duration-brick-settings.selectors';

@Component({
   selector: 'samweb-presence-duration-brick-settings',
   templateUrl: './presence-duration-brick-settings.component.html',
   styleUrls: ['./presence-duration-brick-settings.component.scss'],
})
export class PresenceDurationBrickSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   brickInstanceId: string;

   public showProgressbar$: Observable<boolean>;
   public showDurationAsText$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.showProgressbar$ = this.store.select(PresenceDurationBrickSettingsStateSelectors.getIsProgressbarShown).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showDurationAsText$ = this.store.select(PresenceDurationBrickSettingsStateSelectors.getIsTextShown).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeShowProgressbar(value: boolean) {
      this.store.dispatch(new ChangeShowProgressbar(this.brickInstanceId, value));
   }

   changeShowDurationAsText(value: boolean) {
      this.store.dispatch(new ChangeShowDurationAsText(this.brickInstanceId, value));
   }
}
